module.exports = __webpack_public_path__ + "static/item-section-8-143685f4a0c694fb389dca74f72c7125.png";